import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	access: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.access.access',
		defaultMessage: 'People and access',
		description: 'title for project internal-access navigation item',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.access.title',
		defaultMessage: 'Project settings',
		description: 'Title for project settings navigation panel',
	},
	customerPermissions: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.access.customer-permissions',
		defaultMessage: 'Customer permissions',
		description: 'Settings navigation menu link for a service project',
	},
});
